import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, FadeUp } from "@/components/Reveal";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo("Page not found", "This page does not exist. Head back to ONWARD MEDIA.");
  return (
    <div data-testid="not-found-page" className="mx-auto flex min-h-[80vh] max-w-[1440px] flex-col justify-center px-6 pb-24 pt-36 lg:px-12">
      <p className="font-mono text-xs font-medium uppercase tracking-[0.25em] text-saffron">404 — रास्ता नहीं मिला</p>
      <h1 className="mt-5 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-paper sm:text-6xl lg:text-7xl">
        <MaskedLines inView={false} delay={0.1} lines={["This booth", <span key="x" className="ribbon-text font-hindi normal-case tracking-normal">खाली है.</span>]} />
      </h1>
      <FadeUp delay={0.3}>
        <p className="mt-8 max-w-lg text-base text-zinc-400">The page you are looking for has moved or never existed. Let's get you back on the campaign trail.</p>
        <Link to="/" data-testid="not-found-home" className="btn-ribbon group mt-10 inline-flex items-center gap-2 rounded-full px-8 py-4 font-mono text-xs font-medium uppercase tracking-[0.15em] text-white">
          Back to home <ArrowUpRight className="h-4 w-4" />
        </Link>
      </FadeUp>
    </div>
  );
}
